<template>
  <div class="upload-button">
    <input
      id="file"
      :disabled="!canUpload"
      type="file"
      name="file"
      style="display: none"
      accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,audio/*,video/,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
      @change="onChange"
    />
    <label v-if="canUpload" for="file" class="add-file-errand">
      <img src="@/assets/icon-add-errand.svg" alt="" />
      {{ $t('general__data__file-add') }}
    </label>
    <p v-else>{{ $t('general__data__files-no-available') }}</p>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
interface FILE_UPLOAD_PROPS {
  canUpload?: boolean
}
interface FILE_UPLOAD_EMITS {
  (e: 'upload', file: File): void
}

const props = withDefaults(defineProps<FILE_UPLOAD_PROPS>(), { canUpload: true })
const { canUpload } = toRefs(props)
const emits = defineEmits<FILE_UPLOAD_EMITS>()

function onChange(event: Event) {
  const files = (event.target as HTMLInputElement).files
  if (!files) return
  emits('upload', files[0])
}
</script>

<style scoped>
.add-file-errand {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  align-items: center;
}
</style>
